import {createStore, applyMiddleware, combineReducers, compose} from 'redux';
import thunk from 'redux-thunk';
import loadingReducer from './reducers/loadingReducer';
import snackbarReducer from './reducers/snackbarReducer';
import instanceReducer from './reducers/instanceReducer';
import asLinkReducer from './reducers/asLinkReducer';

const rootReducer = combineReducers({
    instance: instanceReducer,
    snackbar: snackbarReducer,
    loading: loadingReducer,
    asLink: asLinkReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(
    rootReducer,
    composeEnhancers(
        applyMiddleware(thunk)
    )
);
